import * as actions from "./actions";
import mutations from "./mutations";

const state = {
  layouts: {},
  interfaces: {},
  pages: {}
};

export default {
  state,
  actions,
  mutations
};
